const formContextKey = Symbol("formContextKey");
const formItemContextKey = Symbol("formItemContextKey");

export { formContextKey, formItemContextKey };
//# sourceMappingURL=constants.mjs.map
